module.exports = __webpack_public_path__ + "img/bg_base.729fe993.png";